module.exports = __webpack_public_path__ + "static/media/mobile-nav-log-out.5b10d484.svg";